import { IS_LOADING } from '@/store/types/root/actions-types';
import { 
    EMPLOYEE_CREATE_REQUEST, 
    EMPLOYEE_UPDATE_REQUEST, 
    EMPLOYEE_DELETE_REQUEST,
    EMPLOYEE_ACTIVATE_REQUEST,
    EMPLOYEE_DEACTIVATE_REQUEST, 
    GET_EMPLOYEES_REQUEST,
    UPDATE_PROFILE_REQUEST,
    MANAGE_ADMIN_USER,
    CHANGE_PASSWORD_REQUEST,
    GET_USER_REQUEST,
    USER_IMAGE_UPLOAD_REQUEST
    } 
    from './action-types';
import {
    ADD_EMPLOYEES_TO_LIST, 
    ADD_EMPLOYEE_TO_LIST, 
    DELETE_EMPLOYEE_FROM_LIST,
    DEACTIVATE_EMPLOYEE_FROM_LIST,
    ACTIVATE_EMPLOYEE_FROM_LIST,
    UPDATE_EMPLOYEE_IN_LIST,
    UPDATE_ADMIN_IN_LIST } 
    from "./mutation-types"

import api from "@/api/api"

export default {

    [GET_EMPLOYEES_REQUEST]: async ({  commit })=>{
        let response = {}
        try {
            
            response =   await api.get("/users")
            if(response.data.statusCode === 200){
                const reponseBody = response.data.body
                commit(ADD_EMPLOYEES_TO_LIST, reponseBody)
            }
        } catch (err) {
            console.log(err)
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [EMPLOYEE_CREATE_REQUEST]: async ({ commit }, body)=>{
        let response = {}
        if(body.id)
            delete body.id
            
        if(body.default_points == 0)
            delete body.default_points
        try {
            response =   await api.post("/admin/users", body)
            const reponseBody = response.data.body
            if(response.data.statusCode === 200){
                if(reponseBody.message === "User created."){
                    body.id = reponseBody.id
                    commit(ADD_EMPLOYEE_TO_LIST, body)
                }    
            }
            return response
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [EMPLOYEE_UPDATE_REQUEST]: async ({state, commit }, body)=>{

        const originalBody = {...body}
        if(originalBody.group !== "LEAD")
            delete body.group
        
        delete body.username
        delete body.role
        let response = {}            
        let oldEmployee = state.employeesList.filter(item=>{ return item.id == body.id})
        oldEmployee = oldEmployee.length > 0 ? oldEmployee[0] : {}

        try{
            response =   await api.put("/admin/users/" + body.id, body)
            if(response.data.statusCode === 200){
                if(response.data.body.message === "User Updated."){
                    body.first_name = body.fname
                    body.last_name = body.lname
                    body.role =  originalBody.group  !== "LEAD" ? oldEmployee.role : originalBody.group
                    body.username = oldEmployee.username
                    delete body.fname
                    delete body.lname
                    commit(UPDATE_EMPLOYEE_IN_LIST, body)
                }
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [MANAGE_ADMIN_USER]: async ({state, commit }, body)=>{

        const originalBody = {...body}
        if(originalBody.group !== "ADMIN")
            delete body.group
        
        delete body.username
        delete body.role
        let response = {}            
        let oldEmployee = state.employeesList.filter(item=>{ return item.id == body.id})
        oldEmployee = oldEmployee.length > 0 ? oldEmployee[0] : {}

        try{
            response =   await api.put("/super-admin/users/" + body.id, body)
            if(response.data.statusCode === 200){
                if(response.data.body.message === "User Updated."){
                    body.first_name = body.fname
                    body.last_name = body.lname
                    body.role =  originalBody.group  !== "ADMIN" ? oldEmployee.role : originalBody.group
                    body.username = oldEmployee.username
                    delete body.fname
                    delete body.lname
                    commit(UPDATE_EMPLOYEE_IN_LIST, body)
                }
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [UPDATE_PROFILE_REQUEST]: async ({state, commit }, body)=>{

        delete body.username
        delete body.role
        let response = {}            
        let oldEmployee = state.employeesList.filter(item=>{ return item.id == body.id})
        oldEmployee = oldEmployee.length > 0 ? oldEmployee[0] : {}

        try{
            response =   await api.put("/profile/" , body)
            if(response.data.statusCode === 200){
                if(response.data.body.message === "User Updated."){
                    body.first_name = body.fname
                    body.last_name = body.lname
                    body.username = oldEmployee.username
                    delete body.fname
                    delete body.lname
                    commit(UPDATE_ADMIN_IN_LIST, body)
                }
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [EMPLOYEE_DELETE_REQUEST]: async ({ commit }, userID)=>{
        let response = {}
        try {
            response =   await api.post("/admin/users/delete", {"id": userID})
            const reponseBody = response.data.body

            if(response.data.statusCode === 200){
                if(reponseBody.message === "User Deleted." )
                 commit(DELETE_EMPLOYEE_FROM_LIST, [userID])
            }

        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },
    [EMPLOYEE_DEACTIVATE_REQUEST]: async ({ commit }, userID)=>{
        let response = {}
        try {
            response =   await api.post("/admin/users/deactivate", {"id": userID})
            const reponseBody = response.data.body

            if(response.data.statusCode === 200){
                reponseBody.message === "User Deactivated." 
                //  commit(DEACTIVATE_EMPLOYEE_FROM_LIST, [userID])
            }

        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },
    [EMPLOYEE_ACTIVATE_REQUEST]: async ({ commit }, userID)=>{
        let response = {}
        try {
            response =   await api.post("/admin/users/activate", {"id": userID})
            const reponseBody = response.data.body

            if(response.data.statusCode === 200){
                reponseBody.message === "User Activated." 
                //  commit(ACTIVATE_EMPLOYEE_FROM_LIST, [userID])
            }

        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [GET_USER_REQUEST]: async ({  commit }, userID)=>{
        let response = {}
        try {
            response =   await api.get("/users/" + userID)
            commit(IS_LOADING, false, { root: true })
            return response
        } catch (err) {
            console.log(err)
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [CHANGE_PASSWORD_REQUEST]: async ({  commit }, body)=>{
        let response = {}
        try {
            response =   await api.post("/users/change-password", body)
            return response
        } catch (err) {
            console.log(err)
        }
        return response
    },
    [USER_IMAGE_UPLOAD_REQUEST]: async ({  commit }, body)=>{
        const  response =   await api.post("/image-upload", body)
        return response
    },
}
